import React from "react";
import {ChatBotIcon} from "@hugeicons/core-free-icons";
import {MiniCard} from "./MiniCard";
import {useDashboard} from "../../../../context/DashboardContext";

export const ChatbotCard = () => {
  const {responseTime} = useDashboard();

  const avgChatbot = (
    responseTime?.filter(i => +i?.avgChatbot > 0)
      ?.map(i => +i?.avgChatbot)
      ?.reduce((prev, next) => prev + next, 0) /
    responseTime?.filter(i => +i?.avgChatbot > 0)?.length
  )?.toFixed(2) || 0;

  const chartData = responseTime?.map(i => ({
    ...i,
    dateCreated: i?.hour,
    duration: i?.avgChatbot?.toFixed(2)
  }));
  const transcribeLabel = avgChatbot != null && !isNaN(avgChatbot)
      ? `${Number(avgChatbot).toFixed(2)}s`
      : "-";
  const hasActivity = chartData?.some(d => Number(d.duration) > 0);



  return (
    <MiniCard
      icon={ChatBotIcon}
      color={"#1979a3"}
      title={transcribeLabel}
      subtitle={"CHATBOT"}
      data={chartData}
      hideChart={!hasActivity}
    />
  );
};
